import { render, staticRenderFns } from "./SettingsWaitlist.vue?vue&type=template&id=ba06f0ce&"
import script from "./SettingsWaitlist.vue?vue&type=script&lang=js&"
export * from "./SettingsWaitlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports